<div class="p-1 bg-white header">
  <div class="d-flex justify-content-between">
    <h3>{{ title }}</h3>
    <div class="d-flex">
      <div class="mr-2">
        <button mat-stroked-button aria-label="Download"
                [disabled]="isDownloading"
                (click)="downloadExcel.emit()">
          <mat-icon class="align-baseline" fontSet="fas" fontIcon="fa-download"></mat-icon>
          Download
        </button>
        <mat-progress-bar mode="indeterminate" color="accent" *ngIf="isDownloading"></mat-progress-bar>
      </div>
      <button mat-stroked-button (click)="navigateBack()" aria-label="Return To List">Return To List</button>
    </div>
  </div>
  <div *ngIf="data" class="d-flex justify-content-center">
    <div>
      <div>
        <strong>Customer Name:</strong>
        <span class="ml-3">{{ data.customerName }}</span>
      </div>
      <div>
        <strong>Customer Number:</strong>
        <span class="ml-3">{{ data.customerNumber }}</span>
      </div>
      <div *ngIf="data?.interestRate">
        <strong>Interest Rate:</strong>
        <span class="ml-3">{{ data.interestRate | currency }}</span>
      </div>
    </div>
    <div class="ml-5">
      <div>
        <div>
          <strong>Address:</strong>
          <span class="ml-2">{{ data.customerAddressA }}</span>
        </div>
        <div *ngIf="data.customerAddressB" class="pl-5 ml-4">{{ data.customerAddressB }}</div>
        <div *ngIf="data.customerCity" class="pl-5 ml-4">{{ data.customerCity }}</div>
      </div>
      <div>
        <strong>Net Amount Due:</strong>
        <span class="ml-3">${{ data.netAmountDue | number:'1.2-2' }}</span>
      </div>
    </div>
  </div>
</div>
<ns-grid
  name="EBiLL_FINANCE"
  class="flex-grow-1"
  [fileName]="title"
  [loading]="loading"
  [columns]="columns"
  [config]="config"
  [data]="data?.carryCostEntries || []"
  (refresh)="refreshGrid.emit()">
</ns-grid>
